@if (form.get("id").value) {
  <div class="menu-sidebar mb-3.5">
    <hard-button
      type="success"
      (click)="open()"
      class="mr-2"
    >
      Добавить
    </hard-button>

    <div></div>

    <hard-form-input
      [config]="{ placeholder: 'base.search' }"
      [(ngModel)]="searchTerm"
      [last]="true"
      (ngModelChange)="filter($event)"
    ></hard-form-input>
  </div>

  @for (item of filteredItems; track item.id) {
    <ui-menu-item
      [menuId]="form.get('id').value"
      [slug]="form.get('slug').value"
      [item]="item"
      (reloadEmit)="loadData()"
      (openEmit)="open($event)"
    ></ui-menu-item>
  }
}
